import React from 'react';
import { Rocket, Smartphone, Video, Camera, ArrowRight } from 'lucide-react';
import HeartBubble from './HeartBubble';
import { services } from '../mock';

const iconMap = { Rocket, Smartphone, Video, Camera };

const Services = () => {
  return (
    <section id="services" className="relative bg-charcoal py-20 md:py-28 overflow-hidden">
      <HeartBubble size={120} className="top-10 left-[6%] float-anim hidden md:block" rotate={-10} />
      <HeartBubble size={80} className="top-32 left-[14%] float-anim-delay hidden md:block" rotate={6} />

      <div className="max-w-6xl mx-auto px-6 text-center relative z-10">
        <h2 className="section-title mb-8">Unsere Services</h2>
        <p className="text-zinc-200 max-w-3xl mx-auto leading-relaxed text-base md:text-lg">
          Als Social Media Agentur unterstützen wir dich dabei, deine
          Online-Präsenz nachhaltig auszubauen. Ob du lokal Kunden gewinnst
          oder deutschlandweit wachsen willst – wir sind dein Partner für erfolgreiches
          Social Media Marketing.
        </p>
        <p className="text-zinc-300 max-w-3xl mx-auto leading-relaxed text-sm md:text-base mt-4">
          Social Media ist das wichtigste Business-Tool, um als Unternehmen die Reichweite
          gezielt zu steigern und langfristigen Erfolg zu sichern. Nutze das Potenzial von
          Instagram und Co., um dein Business digital voranzubringen!
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-14 text-left max-w-6xl mx-auto">
          {services.map((s) => {
            const Icon = iconMap[s.icon];
            return (
              <div key={s.id} className="service-card">
                <div className="service-card-img">
                  <div className="relative w-32 h-32 flex items-center justify-center">
                    <div
                      className="absolute inset-0 rounded-2xl"
                      style={{
                        background:
                          'linear-gradient(135deg, #1E3A8A 0%, #1E40AF 100%)',
                        transform: 'rotate(-8deg)',
                      }}
                    />
                    <Icon className="relative w-16 h-16 text-white" strokeWidth={2.2} />
                  </div>
                </div>
                <div className="px-6 pt-6">
                  <h3 className="font-display text-2xl text-[#1a1a1a] mb-3">{s.title}</h3>
                  <p className="text-[#1a1a1a] font-semibold text-sm mb-4">{s.tagline}</p>
                  <p className="text-[#2a2a2a] text-sm leading-relaxed">{s.description}</p>
                  <a
                    href="#contact"
                    className="mt-6 inline-flex items-center gap-2 font-heavy text-[#1a1a1a] underline-offset-4 hover:underline"
                  >
                    Mehr erfahren <ArrowRight className="w-4 h-4" />
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
